import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=3d89de88&scoped=true&lang=html&"
import script from "./Newsletter.vue?vue&type=script&lang=js&"
export * from "./Newsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d89de88",
  null
  
)

export default component.exports